module.exports = __webpack_public_path__ + "img/0Q3B1891_L_Foamcore.75a8d1dc.jpg";